import React from "react";
import { PageHeader } from "../../../components";

export default function GENERALMANAGER() {
  return (
    <div className="page-content">
      <PageHeader title="Management Details" page="management details" />
      {/* <!-- Content --> */}
      <div className="page-content">
        {/* <!-- Breadcrumb row END --> */}
        {/* <!-- contact --> */}
        <div className="content">
          {/* <!-- About Company --> */}
          <div className="section-fullbg-gray content-inner bg-gray ">
            <div className="container">
              <div className="row">
                <div className="col-md-5 col-sm-12 hidden-sm">
                  <img
                    src="./assets/images/members/LCC_GM.jpeg"
                    alt=""
                    className="m-b30"
                    width="440"
                  />
                </div>
                <div className="col-md-7 col-sm-12">
                  <h3 className="h3">MR. TOLU EMMANUEL</h3>
                  <div className="dlab-separator bg-primary"></div>
                  <h4 className="font-weight-3 00">
                    Tolu Emmanuel is a seasoned administrator, strategist, and leader with a proven track record of driving operational excellence and organizational growth. Currently serving as the General Manager of Lagos Country Club, he brings a strong blend of vision, discipline, and people-centered leadership to one of Nigeria’s most prestigious social and recreational institutions.

A graduate of Political Science from Kogi State University, Tolu Emmanuel combines academic insight with practical expertise to deliver results in governance, administration, and organizational management. His grounding in political science has sharpened his skills in policy formulation, negotiation, human relations, and institutional development—competencies that continue to guide his leadership style and decision-making.

With years of experience in management, operations, and governance, he has built a reputation for fostering service excellence, innovation, and accountability. His leadership is marked by a deep commitment to efficiency, member satisfaction, and sustainable development. He has successfully spearheaded initiatives that streamline operations, strengthen organizational culture, and enhance the overall member experience.

At Lagos Country Club, he oversees multi-departmental functions including administration, finance, hospitality, sports, and member services—ensuring seamless coordination and strategic alignment with the club’s mission. He is passionate about building systems that empower staff, optimize resources, and deliver outstanding value to members.

Known for his integrity, foresight, and ability to inspire teams, Tolu Emmanuel embodies the ethos of excellence and professionalism. His leadership continues to position Lagos Country Club as not only a hub of leisure and recreation but also as a model for organizational performance and service delivery in Nigeria’s hospitality and club industry.
                  </h4>
                  <h4 className="font-weight-3 00">
                
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- contact area  END --> */}
      </div>
    </div>
  );
}
